import reducer from "./reducer";
export { default as Geoanalysis } from "./components/index";
export { default as geoanalysisReducerName } from "./constants";
export default reducer;
